// extracted by mini-css-extract-plugin
module.exports = {"root":"ResetCommPopup_root__YGq1m","checkboxLabel":"ResetCommPopup_checkboxLabel__iYbwb","footer":"ResetCommPopup_footer__1GHUI"};